import { render } from "./ProductPill.vue?vue&type=template&id=3d6f025d&ts=true"
import script from "./ProductPill.vue?vue&type=script&lang=ts"
export * from "./ProductPill.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__